<template>
    <section id="modern" class="bg-matt relative py-3 md:py-5 overflow-hidden text-secondary">
        <div class="text-center relative z-40 mx-auto">
            <h3 class="text-5xl font-extrabold md:text-8xl font-DMSans">
                <span class="block">Your Modern</span>
                <span class="text-primary">Workflow</span> Starts Here
            </h3>
            <p class="mt-3 text-white text-center md:text-xl">
                Take the First Step to Efficiency
            </p>
            <div class="flex flex-col items-center justify-center pt-10 gap-2">
                <a href="/register" class="w-full sm:w-auto text-center px-14 py-3 bg-primary text-secondary font-dmsans rounded-full shadow-button-secondary hover:bg-white hover:text-primary transition duration-300">
                    Get Started Now
                </a>
                <div class="flex items-center gap-1">
                    <a
                        v-for="(social, index) in AjilitySocialMedia.data"
                        :key="index"
                        :href="social.socialLink"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="flex"
                    >
                        <img
                            :src="social.icon"
                            :alt="social.title"
                            class="h-8 w-8"
                        />
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
section {
    padding: 0 2rem;
}

section p {
    color: #222;
}

.subtitle {
    position: relative;
    border-radius: 50px;
}

.subtitle:before {
    content: "";
    display: inline-block;
    width: 30px;
    vertical-align: middle;
    height: 1px;
    position: absolute;
    top: 50%;
    left: -18%;
    transform: translate(-50%);
    background: #ff0000;
}

.text-white.subtitle:before {
    background: #fff;
}

@media(min-width:1200px) {
    section {
        padding: 0 8rem;
    }
}
</style>
<script setup lang="ts">
import {AjilitySocialMedia} from "@/Enums/Ajility";
</script>
